import React from "react";
import {
    FeaturingLabelOverlayContainer,
    CustomFeaturingLabelOverlay
} from "./FeaturingLabelOverlay.styles";
import { Typography } from "@mui/material";

export interface CustomFeaturingLabelOverlayProps {
    label: string;
}

export const FeaturingLabelOverlay = ({
    label = ""
}: CustomFeaturingLabelOverlayProps) => {
    return (
        <FeaturingLabelOverlayContainer>
            <CustomFeaturingLabelOverlay>
                <Typography>Featuring:</Typography>
                <span>✨ {label} ✨</span>
            </CustomFeaturingLabelOverlay>
        </FeaturingLabelOverlayContainer>
    );
};

export interface FeaturingLabelOverlayProps extends React.ComponentProps<typeof FeaturingLabelOverlay> {
    as?: React.ElementType;
}

FeaturingLabelOverlay.displayName = "FeaturingLabelOverlay";